import { useAppSelector } from '@unistocks/shared/hooks/redux-hooks';
import { selectSidebarPinned } from '@unistocks/shared/store/root.slice';
import { useMedia } from 'tamagui';

export const useSidebarPinned = () => {
  const media = useMedia();
  const sidebarPinned = useAppSelector(selectSidebarPinned);

  return media.lg && sidebarPinned;
};
